import "../i18nFallback";
import { Sentry } from "../sentryInstrumentReact";
import React from 'react';
import Cookies from 'js-cookie';

import { useCart } from './CartContext';
import CheckoutSummaryItem from "./CheckoutSummaryItem";

function CheckoutSummary() {
  const {
    checkoutFormData,
    shippingSameAsBilling,
    cart, 
    setCart,
    cartTotal, 
    setCartTotal, 
    cartSubtotal,  
    cartTax, 
    shipping, 
    shippingRequired,
    donation,
    setDonation,
    discountCode, 
    discountAmount,
    fetchingShippingCost,
    fetchingTaxCost,
  } = useCart();
  const displayTaxRow = 
    (checkoutFormData.shipping.country === "USA" && shippingRequired === true) || 
    (checkoutFormData.billing.country === "USA" && shippingSameAsBilling) ||
    (checkoutFormData.billing.country === "USA" && shippingRequired === false);

  const csrftoken = Cookies.get('csrftoken');
  const formattedCartSubtotal = parseFloat(cartSubtotal).toLocaleString("en-US", {
    style: 'currency',
    currency: 'USD'
  })
  const formattedCartTotal = parseFloat(cartTotal).toLocaleString("en-US", {
    style: 'currency',
    currency: 'USD'
  });


  // cancels donation
  async function removeDonation() {
    try {
      const response = await fetch("/store/_api/cart/donation/", {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": csrftoken
        },
      });
      const cartObject = await response.json();
      setCart(cartObject);
      setCartTotal(parseFloat(cartObject.total).toFixed(2));
      setDonation('');
    } catch(error) {
      Sentry.captureException?.(error, {stage: "remove donation"});
    }
  }


  return (
    <>
        <h2>{window.gettext("Summary")}</h2>
        <table className="table checkout-cart-table mb-0">
        <tbody>
            { cart.items.filter(item => item.quantity > 0).map((item) => (
            <CheckoutSummaryItem item={item} key={item.id} />
            ))}
            <tr className="hr">
            <td colSpan="2"><hr /></td>
            </tr>
            <tr className="subtotal-row">
            <th>{window.gettext("Subtotal")}</th>
            <td>{formattedCartSubtotal}</td>
            </tr>
            {discountAmount > 0 && 
            <tr className="discount-row">
                <th>{window.gettext("Discount")} <span>({discountCode})</span></th>
                <td className="text-success">-${discountAmount}</td>
            </tr>
            }
            {shippingRequired && 
            <tr className={fetchingShippingCost ? "shipping-row fetch-loading" : "shipping-row"}>
            <th>{window.gettext("Shipping")}</th>
            <td>{shipping.cost !== 0 ? `$${shipping.cost}` : `—`}</td>
            </tr>
            }
            {displayTaxRow && 
            <tr className={fetchingTaxCost ? "shipping-row fetch-loading" : "shipping-row"}>
                <th>{window.gettext("Taxes")}</th>
                <td>{cartTax !== 0 ? `$${cartTax}` : `—`}</td>
            </tr>
            }
            {donation > 0 && 
            <tr className="donation-row">
                <th>{window.gettext("Donation")}</th>
                <td><a className="remove btn-tiny" onClick={removeDonation}>{window.gettext("remove")}</a>&nbsp;${donation}</td>
            </tr>
            }
            <tr className="hr">
            <td colSpan="2"><hr /></td>
            </tr>
            <tr className="total-row">
            <th><strong>{window.gettext("Total")}</strong></th>
            <td id="order-total"><strong>{formattedCartTotal}</strong></td>
            </tr>
        </tbody>
        </table>
    </>
  );
}

export default CheckoutSummary;
